import { motion } from "framer-motion";

function Header({ playAnimation }) {
  return (
    <header>
      <video src={process.env.PUBLIC_URL + "/video.mp4"} loop autoPlay muted></video>
      
      <div className="header-content-wrapper">
         <motion.img 
            className="header-logo"
            src={process.env.PUBLIC_URL + "/img/tss.png"} 
            alt="TSS Logo" 
            initial={{ opacity: 0, scale: 0.8 }}
            animate={playAnimation ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.8 }}
         />
         <motion.div 
            className="header-line"
            initial={{ height: 0 }}
            animate={playAnimation ? { height: '100%' } : { height: 0 }}
            transition={{ duration: 1, delay: 0.5 }}
         />
         <div className="header-text-container">
            {['Subsea', 'Cable', 'Services'].map((text, index) => (
              <motion.span
                key={index}
                initial={{ x: 50, opacity: 0 }}
                animate={playAnimation ? { x: 0, opacity: 1 } : { x: 50, opacity: 0 }}
                transition={{ duration: 0.5, delay: 1 + (index * 0.2) }}
              >
                {text}
              </motion.span>
            ))}
         </div>
      </div>

      <div className="headerbg"></div>
    </header>
  );
}
export default Header;